// Autogenerated file
export const gasStationVisitStatusesEnum = {
    Visited: "Visited",
    VisitedWithoutRefueling: "VisitedWithoutRefueling",
    Skipped: "Skipped",
    DeletedByLogist: "DeletedByLogist",
    VisitedWithoutPlanning: "VisitedWithoutPlanning",
};
export const gasStationVisitStatuses = [
    { label: "Посетил", value: "Visited" },
    { label: "Посетил, без заправки", value: "VisitedWithoutRefueling" },
    { label: "Пропустил", value: "Skipped" },
    { label: "Удалена логистом", value: "DeletedByLogist" },
    { label: "Посещена без планирования", value: "VisitedWithoutPlanning" },
];
